import { Box, Card, CardActionArea, CardContent } from '@material-ui/core';
import React, { Fragment} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    margin: theme.spacing(4,0,8), 
    },
    container:{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(225px, 1fr))"
    },
    cardContainer : {
      margin: theme.spacing(1)
    },
    card:{
        padding: 14,
        transition: 'transform .2s',
        '&:hover': { 
            transform: 'scale(1.1)',
         },
        minHeight: 473.14
    },
    media: {
        height: 0,
        paddingBottom: 100 + '%',
        borderWidth: 1,
        borderColor: '#754795'
    },
}));

const ListProductsEskeleton = (props) => {
        const classes = useStyles(props);
        let products = [];

        for (let i = 0; i < props.numItens; i++) {
            products.push({id: i});
        }
        
        return(
            <Fragment>
                <div className={classes.root} style={{backgroundColor: props.backgroundCardsContainer || 'transparent', padding: props.paddingCardsContainer || 0 }}>
                    <Box className={classes.container} >
                    {
                        products.map((product) => {
                            return(
                                <Box key={product.id} className={classes.cardContainer}>
                                    <Card className={classes.card}>
                                        <CardActionArea  component="div" disableRipple>
                                            <Skeleton variant="rect" className={classes.media}  />
                                            <CardContent className={classes.content} >
                                                <Skeleton variant="text" width="100%" />
                                                <Skeleton variant="text" width="80%" />
                                                <Skeleton variant="text" width="60%" />
                                                <Skeleton variant="text" width="50%" />
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Box>
                            )
                        })
                    }
                    </Box>
                </div>
            </Fragment>
        );
}

export default ListProductsEskeleton;